// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__8XjMP","ranges":"BmiRanges_ranges__W8p4r"};